import React from 'react';
import { useAuth } from '../context/AuthContext';
import TopNavbar from '../components/TopNavbar';
import MainHeader from '../components/MainHeader';
import Footer from '../components/Footer';

const UserSetts = () => {
  const { user } = useAuth();

  const getUserDisplayName = () => {
    if (user?.first_name && user?.last_name) return `${user.first_name} ${user.last_name}`;
    return user?.email || 'User';
  };

  return (
    <div className="App bg-gray-50 min-h-screen">
      <TopNavbar />
      <MainHeader />

      {/* Content */}
      <div className="max-w-3xl mx-auto py-10 px-4">
        <div className="bg-white rounded-xl shadow-lg p-6 space-y-6">

          {/* Profile Info */}
          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Profile</h2>
            <p className="text-gray-700">
              <strong>Name:</strong> {getUserDisplayName()}
            </p>
            <p className="text-gray-700">
              <strong>Email:</strong> {user?.email || 'N/A'}
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default UserSetts;
